<template>
  <div class="d-flex align-items-center container-fluid">
    <div class="d-flex align-items-center container-fluid bg-beige rounded p-2">
      <h5 class="mb-0 me-auto">...</h5>

      <div class="d-flex gap-2">
        <!-- Structured Visits -->
        <!-- Structured Visits -->
        <router-link
          class="btn btn-outline-secondary btn-sm position-relative d-flex flex-column align-items-center text-center"
          :to="{ name: 'Cashier' }"
        >
          <span>Structured Visits Bills</span>
          <small style="font-size: 0.75rem; color: #333">For Visits </small>

          <span
            class="badge rounded-pill bg-danger position-absolute translate-middle"
            style="
              top: 10%;
              right: 5%;
              min-width: 22px;
              height: 22px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.8rem;
            "
          >
            {{ walkin }}
          </span>
        </router-link>

        <!-- Walkin Bills -->
        <router-link
          class="btn btn-primary btn-sm position-relative d-flex flex-column align-items-center text-center"
          :to="{ name: 'Cashier Walkin Clients' }"
        >
          <span>Walkin Bills</span>
          <small style="font-size: 0.75rem; color: #fff; opacity: 0.85"
            >Pending Bills</small
          >

          <span
            class="badge rounded-pill bg-warning text-dark position-absolute translate-middle"
            style="
              top: 10%;
              right: 5%;
              min-width: 22px;
              height: 22px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.8rem;
              border: 2px solid #fff;
            "
          >
            {{ visitor }}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "CashierNav",
  data() {
    return {
      walkin: "",
      visitor: "",
    };
  },
  props: {
    structuredCount: {
      type: Number,
      default: 0,
    },
    walkinCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    async fetch_count() {
      const url = "cashier_counter";
      const response = await generalApiRequest(url, "GET", {}, 1);
      console.log(response);

      this.walkin = response.in_visits_counts;
      this.visitor = response.walkin_count;
    },
  },

  mounted() {
    this.fetch_count();
  },
};
</script>

<style scoped>
.bg-beige {
  background-color: beige;
}
</style>
